"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOrderQuantity = getOrderQuantity;
function getOrderQuantity({
  addedItems,
  offers,
  shoppingBagItems,
  subscriptions
}) {
  return addedItems.reduce((total, item) => total + (item.isAvailable ? item.requestedQuantity : 0), 0) + shoppingBagItems.reduce((total, item) => total + (item.isAvailable ? item.requestedQuantity : 0), 0) + subscriptions.reduce((total, subscription) => total + subscription.packages.reduce((subTotal, subscriptionPackage) => subTotal + subscriptionPackage.items.reduce((itemTotal, subscriptionPackageItem) => itemTotal + (subscriptionPackageItem.isAvailable ? subscriptionPackageItem.requestedQuantity : 0), 0), 0), 0) + offers.reduce((total, offer) => total + offer.items.reduce((subTotal, offerItem) => subTotal + (offerItem.isAvailable ? offerItem.requestedQuantity : 0), 0), 0);
}